import { gql } from "graphql-tag";

export const SIGN_IN_ATTEMPT = gql`
  mutation UserLoginPreflight($username: String!) {
    userLoginPreflight(username: $username) {
      login {
        username
        verified
        method
      }
    }
  }
`;

export const USER_LOGIN = gql`
  mutation UserLogin($username: String!, $password: String!) {
    userLogin(username: $username, password: $password) {
      success
      token
    }
  }
`;

export const CREATE_NEW_USER = gql`
  mutation CreateApplicantAccount($data: UserInput!) {
    createUser(data: $data) {
      id
    }
  }
`;
